import LoadingSpinner from "components/components/LoadingSpinner/LoadingSpinner";
import LastUpdatedText from "components/shared/LastUpdated/LastUpdatedText/LastUpdatedText";
import Panel from "components/shared/Panel/Panel";
import styled from "styled-components";
import fonts from "styles/fonts";

export const PanelWithVerticalMargins = styled(Panel)`
  margin: 8px 0 16px;
  padding: 20px 0;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

export const Title = styled.h2`
  && {
    font-size: 2em;
    margin-bottom: 24px;
    font-weight: 900;
  }
`;

export const HorizontalLayout = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: center;
`;

export const MinHeight = styled.div`
  min-height: 150px;
`;

export const ErrorWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  font-size: ${fonts.medium};
  font-weight: bold;

  padding-top: 30px;
`;

export const FixedSizeLoadingSpinner = styled(LoadingSpinner)`
  height: 70px;
`;

export const LastUpdatedTextWithMargins = styled(LastUpdatedText)`
  margin-top: 10px;
  margin-left: 10px;
`;
